var _path, _path2;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
const SvgFees2 = props => /*#__PURE__*/React.createElement("svg", _extends({
  xmlns: "http://www.w3.org/2000/svg",
  width: 32,
  height: 32,
  fill: "none",
  viewBox: "0 0 32 35"
}, props), _path || (_path = /*#__PURE__*/React.createElement("path", {
  stroke: "#CACACA",
  strokeLinecap: "round",
  strokeLinejoin: "round",
  strokeWidth: 1.5,
  d: "m13.57 25.45 10.354-10.9M14.218 17.283c1.076 0 1.948-.918 1.948-2.05s-.872-2.05-1.948-2.05c-1.075 0-1.947.918-1.947 2.05s.871 2.05 1.947 2.05M24.573 26.817c1.076 0 1.948-.918 1.948-2.05s-.872-2.05-1.948-2.05c-1.075 0-1.947.918-1.947 2.05s.872 2.05 1.947 2.05"
})), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
  stroke: "#CACACA",
  strokeLinecap: "round",
  strokeLinejoin: "round",
  strokeWidth: 1.5,
  d: "M19 36.667c8.745 0 15.834-7.462 15.834-16.667S27.744 3.334 19 3.334 3.167 10.795 3.167 20 10.256 36.667 19 36.667"
})));
export default SvgFees2;